module.exports = __webpack_public_path__ + "assets/ic_character1.bd754edb.svg";